import { ScanCouponService } from "./scan-qr-coupon.service";

export const SERVICES = [
  ScanCouponService,
];
